var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSearch = function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m28.416 26.784-8.768-8.768a9.13 9.13 0 0 0 1.92-5.6c0-5.056-4.128-9.184-9.184-9.184-5.088 0-9.216 4.128-9.216 9.184S7.296 21.6 12.352 21.6c2.016 0 4-.672 5.6-1.92l8.768 8.8a1.16 1.16 0 0 0 1.664 0c.224-.224.352-.512.352-.832a1.05 1.05 0 0 0-.32-.864m-16.064-7.552c-3.744 0-6.816-3.072-6.816-6.816S8.608 5.6 12.352 5.6s6.816 3.072 6.816 6.816-3.04 6.816-6.816 6.816"
  })));
};
export default SvgSearch;